import Footer from "../../components/footer";
import Arrow from "../../components/Arrow";
import CapabilitiesTextContainer from "../../components/capabilitiesTextContainer";
import React from "react";
import { NavLink } from "react-router-dom";

const Sitemap = () => {
  return (
    <>
      <div className="md:py-12 py-4 md:px-12 px-4">
        <div className="lg:text-2xl text-xl font-semibold lg:mb-12 mb-4">
          Sitemap
        </div>
        <div
          className="lg:w-fit lg:m-auto hover:bg-bg-neutral_rose cursor-pointer lg:hover:scale-105 transition-all"
          id="homepage"
        >
          <NavLink to="/" data-gtm-id="item-30">
            <CapabilitiesTextContainer>
              <div className="text-lg font-semibold">ExploR&D Homepage</div>
              <div className="mx-8">
                <ul>
                  <li>Introduction to Lilly ExploR&D</li>
                  <li>Benefits of partnering with us</li>
                </ul>
              </div>
            </CapabilitiesTextContainer>
          </NavLink>
        </div>
        <div className="flex flex-col lg:flex-row gap-8 lg:mt-12 mt-8 items-start lg:ml-0 justify-between relative">
          <div className="relative lg:w-fit w-full">
            <div
              className="absolute bg-red-500 lg:left-1/2 lg:top-0  left-0 top-1/2 ml-5 lg:ml-0"
              id="about-page-ref"
            ></div>
            <div
              className="lg:mt-12 ml-12 lg:ml-0 hover:bg-bg-neutral_rose cursor-pointer lg:hover:scale-105 transition-all"
              id="about-page"
            >
              <NavLink to="/about">
                <CapabilitiesTextContainer>
                  <div data-gtm-id="item-2" className="text-lg font-semibold">
                    About Lilly ExploR&D
                  </div>
                  <div className="mx-8">
                    <ul>
                      <li>Our Catalyze360 Mission</li>
                      <li>Suite of R&D Solutions</li>
                      <li>Our Leadership</li>
                    </ul>
                  </div>
                </CapabilitiesTextContainer>
              </NavLink>
            </div>
          </div>
          <div className="relative lg:w-fit w-full">
            <div
              className="absolute bg-red-500 lg:left-1/2 lg:top-0  left-0 top-1/2 ml-5 lg:ml-0"
              id="capabilities-ref"
            ></div>
            <div
              className="lg:mt-12 ml-12 lg:ml-0 hover:bg-bg-neutral_rose cursor-pointer lg:hover:scale-105 transition-all"
              id="capabilities"
            >
              <NavLink to="/capabilities">
                <CapabilitiesTextContainer>
                  <div data-gtm-id="item-3" className="text-lg font-semibold">
                    Our Capabilities
                  </div>
                  <div className="mx-8">
                    <ul>
                      <li>Our Full Stack Capabilities</li>
                      <li>Integrated Development Plan</li>
                      <li>Our Capabilities Slides</li>
                    </ul>
                  </div>
                </CapabilitiesTextContainer>
              </NavLink>
            </div>
          </div>
          <div className="relative lg:w-fit w-full">
            <div
              className="absolute bg-red-500 lg:left-1/2 lg:top-0  left-0 top-1/2 ml-5 lg:ml-0"
              id="testimonials-ref"
            ></div>
            <div
              className="lg:mt-12 ml-12 lg:ml-0 hover:bg-bg-neutral_rose cursor-pointer lg:hover:scale-105 transition-all"
              id="testimonials"
            >
              <NavLink to="/testimonials">
                <CapabilitiesTextContainer>
                  <div data-gtm-id="item-4" className="text-lg font-semibold">
                    Testimonials
                  </div>
                  <div className="mx-8">
                    <ul>
                      <li>Partnership with BioAge</li>
                      <li>Notable testimonials</li>
                    </ul>
                  </div>
                </CapabilitiesTextContainer>
              </NavLink>
            </div>
          </div>
          <div className="relative lg:w-fit w-full">
            <div
              className="absolute bg-red-500 lg:left-1/2 lg:top-0  left-0 top-1/2 "
              id="contact-us-ref"
            ></div>
            <div
              className="absolute bg-red-500 lg:left-1/2 lg:top-0  left-0 top-1/2 ml-5"
              id="contact-us-ref-2"
            ></div>
            <div
              className="lg:mt-12 ml-12 lg:ml-0 hover:bg-bg-neutral_rose cursor-pointer lg:hover:scale-105 transition-all"
              id="contact-us"
            >
              <NavLink to="/contact" data-gtm-id="item-31">
                <CapabilitiesTextContainer>
                  <div className="text-lg font-semibold">Contact Us</div>
                  <div className="mx-8">
                    <ul>
                      <li>Form for reaching out to us</li>
                    </ul>
                  </div>
                </CapabilitiesTextContainer>
              </NavLink>
            </div>
          </div>

          <div
            className="absolute bg-red-500 left-1/2 mr-2"
            id="intermediate"
          ></div>
        </div>
        <div className="hidden lg:block">
          <Arrow
            fromId="homepage"
            toId="intermediate"
            type="mobile"
            fromMiddle
            dashed
          />
          <Arrow fromId="about-page-ref" toId="contact-us-ref" dashed />
          <Arrow
            fromId="about-page-ref"
            toId="about-page"
            type="mobile"
            fromMiddle
            dashed
          />
          <Arrow
            fromId="capabilities-ref"
            toId="capabilities"
            type="mobile"
            fromMiddle
            dashed
          />
          <Arrow
            fromId="testimonials-ref"
            toId="testimonials"
            type="mobile"
            fromMiddle
            dashed
          />
          <Arrow
            fromId="contact-us-ref"
            toId="contact-us"
            type="mobile"
            fromMiddle
            dashed
          />
        </div>
        <div className="lg:hidden">
          <Arrow fromId="homepage" toId="contact-us-ref" dashed type="mobile" />
          <Arrow fromId="about-page-ref" toId="about-page" dashed />
          <Arrow fromId="capabilities-ref" toId="capabilities" dashed />
          <Arrow fromId="testimonials-ref" toId="testimonials" dashed />
          <Arrow fromId="contact-us-ref-2" toId="contact-us" dashed />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Sitemap;
